import { formatDateSafe } from '../../../../../utilities/dateHelpers';
import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { CellProps } from '../../types';
import { CellEventsHandler } from '../formatters';

const Formatter = (cellProps: CellProps) => {
  return (
    <CellEventsHandler cellProps={cellProps}>
      {formatDateSafe(cellProps.row.expectedDepositDate, 'DD MMM YYYY', cellProps.row.expectedDepositDate || '')}
    </CellEventsHandler>
  );
};

export const ExpectedDepositDateColumn = (): IColumn => ({
  item: {
    key: 'expectedDepositDate',
    name: 'Expected deposit',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(128px, 1fr)',
    formatter: Formatter,
  },
  visible: ({ isDepositDateVisible }) => isDepositDateVisible!,
});
